import { UserIcon } from "../../../assets/UserIcon";
import { PhoneIcon } from "../../../assets/PhoneIcon";
import { MailIcon } from "../../../assets/MailIcon";

export default function InfoStep({
  isTestDriveFlow,
  selectedDate,
  selectedTime,
  formatDate,
  formatSlot2h,
  name,
  phone,
  email,
  setName,
  setPhone,
  setEmail,
  hasServiceQuestions,
  onContinue,
  onBackToTime,
}: {
  isTestDriveFlow: boolean;
  selectedDate: Date | null;
  selectedTime: string | null;
  formatDate: (d: Date) => string;
  formatSlot2h: (t: string) => string;

  name: string;
  phone: string;
  email: string;
  setName: (v: string) => void;
  setPhone: (v: string) => void;
  setEmail: (v: string) => void;

  hasServiceQuestions: boolean;
  onContinue: () => void;
  onBackToTime?: () => void;
}) {
  return (
    <div>
      {isTestDriveFlow && (
        <p className="tdb-infoSummary">
          {selectedDate && formatDate(selectedDate)} —{" "}
          {selectedTime ? formatSlot2h(selectedTime) : ""}
        </p>
      )}

      <div className="tdb-fields">
        <div className="tdb-field">
          <UserIcon className="tdb-fieldIcon" />
          <input
            name="name"
            type="text"
            required={true}
            placeholder="Votre nom *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="tdb-input"
          />
        </div>

        <div className="tdb-field">
          <PhoneIcon className="tdb-fieldIcon" />
          <input
            name="tel"
            type="tel"
            required={true}
            placeholder="Votre téléphone *"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="tdb-input"
          />
        </div>

        <div className="tdb-field">
          <MailIcon className="tdb-fieldIcon" />
          <input
            name="email"
            type="email"
            required={true}
            placeholder="Votre email *"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="tdb-input"
          />
        </div>
      </div>

      <button
        type="button"
        onClick={onContinue}
        disabled={!name.trim() || !phone.trim() || !email.trim()}
        className="tdb-primaryBtn"
      >
        {hasServiceQuestions
          ? "Continuer"
          : isTestDriveFlow
            ? "Confirmer ma demande d'essai"
            : "Envoyer mes coordonnées"}
      </button>

      {isTestDriveFlow && onBackToTime && (
        <button type="button" onClick={onBackToTime} className="tdb-linkBtn">
          ← Changer l'horaire
        </button>
      )}
    </div>
  );
}
